import { PaymentMethodEnum } from '@/types/common';
import { Loader } from '../Common/Loader';
import { cn } from '@/utils/cn';

interface LoaderPayButtonProps {
  type: PaymentMethodEnum.GOOGLE_PAY | PaymentMethodEnum.APPLE_PAY | PaymentMethodEnum.PAYPAL;
}

export const LoaderPayButton = ({ type }: LoaderPayButtonProps) => {
  const getButtonClassNames = () => {
    switch (type) {
      case PaymentMethodEnum.GOOGLE_PAY:
        return 'bg-black';
      case PaymentMethodEnum.APPLE_PAY:
        return 'bg-black';
      case PaymentMethodEnum.PAYPAL:
        return 'bg-[#FFC439]';
    }
  };
  return (
    <div
      className={cn(
        'w-full h-11 rounded-md flex items-center justify-center p-spacing-2 gap-2 opacity-50 cursor-not-allowed',
        getButtonClassNames()
      )}
    >
      <Loader size="xs" color="white" />
    </div>
  );
};
